import * as yup from "yup";
import i18next from "config/i18next";
import { VALIDATION_REGEX } from "utils/constants";
import { FilterContainerValidationSchemaTypes } from "./types";
export const validationSchemaAR: yup.SchemaOf<FilterContainerValidationSchemaTypes> =
  yup.object({
    name: yup
      .string()
      .matches(
        VALIDATION_REGEX.expName,
        i18next.t("validations:numbersOrSpecialCharacters")
      ),
    identificationNumber: yup
      .string()
      .min(7, i18next.t("filterPickers:dniLengthError"))
      .matches(
        VALIDATION_REGEX.regDNI,
        i18next.t("validations:numbersOnly")
      ),
    email: yup
      .string()
      .matches(
        VALIDATION_REGEX.regEmail,
        i18next.t("validations:invalidEmailFormat")
      ),
  });
